import { Component, OnInit } from '@angular/core';
import { AppConfigService } from 'src/app/services/app-config/app-config.service';

/**
 * Decide qué vista de pagos de Finanzas renderizar según la preferencia del
 * sistema (default_finance_payments_view: 'tabla' | 'classic'), configurada por el
 * admin en Parámetros de Sistema > Preferencias. Flag independiente del de pagos
 * por persona, para poder prender/apagar cada vista por separado.
 */
@Component({
  selector: 'app-finance-payments-switcher',
  template: `
    <div *ngIf="view === null" class="text-center py-5">
      <div class="spinner-border text-primary" role="status">
        <span class="visually-hidden">Cargando...</span>
      </div>
    </div>
    <app-finance-payments-table *ngIf="view === 'tabla'"></app-finance-payments-table>
    <app-payments *ngIf="view === 'classic'"></app-payments>
  `
})
export class FinancePaymentsSwitcherComponent implements OnInit {

  view: 'tabla' | 'classic' | null = null;

  constructor(private _appConfig: AppConfigService) { }

  async ngOnInit(): Promise<void> {
    try {
      const prefs = await this._appConfig.getPreferences();
      this.view = prefs?.default_finance_payments_view === 'tabla' ? 'tabla' : 'classic';
    } catch (error) {
      console.error(error);
      this.view = 'classic';
    }
  }
}
